import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
    Box,
    Button,
    Stack,
    Typography,
    IconButton,
    Snackbar,
    Alert,
    Paper,
    Divider
} from '@mui/material'
import { Close as X } from '@mui/icons-material'
import DocumentHeader from './Header'
import DocumentFooter from './Footer'
import { DynamicTabsComponent } from '../../components/dynamictabs/DynamicTabsComponent'
import { ResizablePanel, ResizablePanelGroup, ResizableHandle } from '../../components/Resizable/resizable'
import { DraggableDialog } from '../../components/DragableDialogBox/DragableDialogBox'
import {
    setDOCJSON,
    setFocusedServiceID,
    setInitialState,
    setOrgIdConst,
    setActiveTab,
    updateValidationError,
    updateValidationErrorByKey
} from '../../redux/DynamicForms/dynamicFormsActions'
import { Get_Val_By_ServiceKey, getFormFields } from '../../globalhelper/DynamicFormHelpers'
import DocumentHeaderSkeleton from '../../components/skeletons/DocumentHeaderSkeleton'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { showLoader, hideLoader, showAlert } from '../../redux/Common/commonActions'
import { useChangeValByserviceID, usePutDefaultValue_BillExtract, useStoreVals } from '../../hooks/dynamicform.hooks'
import { changeLogs, Set_ORG_ID_CONST } from '../../redux/VR2/vr2Actions'
import { getRequest, getVendorActivityCode, postRequest } from '../../globalhelper/helper'
import { update_dependencyJson } from '../../redux/DynamicForms/dynamicFormsActions'
import Popup from '../../components/SimplePOPUP'
import store from '../../store'
import DialougeBox from '../VR2_Form_Rendering/DialougeBox'
import moment from 'moment'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'

dayjs.extend(customParseFormat)

const EMPTY_ARRAY = [];
const EMPTY_OBJECT = {};

const trim = (str) => {
    return str.replace(/\s+/g, "").toLowerCase();
};

const DisplayContainer = ({ screenName: token, screenAction: action, refName, docId, onBack, From_SearchJSON }) => {
    const dispatch = useDispatch()
    const history = useHistory()
    const footerRef = useRef(null)

    // Selectors (Legacy State)
    const dynamicFormsDocJSON = useSelector(state => state.dynamicForms.DOCJSON || EMPTY_ARRAY)
    const reduxDocJSON = dynamicFormsDocJSON;
    const activeDocJSON = reduxDocJSON;
    const isMounted = useRef(true)


    const one_side_PDF_Key = useSelector(state => state.dynamicForms.one_side_PDF_Key || "")
    const DOCJSON = useSelector(state => state.dynamicForms.DOCJSON || EMPTY_ARRAY)
    const isLoading = useSelector(state => state.common.loading || false)
    const ORG_ID_CONST = useSelector(state => state.dynamicForms.ORG_ID_CONST || "")
    const storeVals = useSelector(
        state => state.dynamicForms.storeVals || EMPTY_OBJECT
    );


    const store_all_vals = useStoreVals();
    const putDefaultValue_BillExtract = usePutDefaultValue_BillExtract();

    const [tableNode, setTableNode] = useState(null);
    const [screenName, setScreenName] = useState(token)
    const [footerOpen, setFooterOpen] = useState(false)
    const [openDragableDialog, setOpenDragableDialog] = useState(false)
    const [render, setRender] = useState(false)
    const [allActivityCodes, setAllActivityCodes] = useState([]);
    const [confirmationDialog, setConfirmationDialog] = useState(null)
    const [popup_table, setPopup_table] = useState(null);
    const changeValByserviceID = useChangeValByserviceID();

    const pdfBlobUrl = useMemo(() => {
        if (!one_side_PDF_Key?.PDF_KEY) return null;
        const isPdf = one_side_PDF_Key?.FILE_TYPE?.toLowerCase()?.endsWith("pdf") || one_side_PDF_Key?.FILE_TYPE?.toLowerCase() === "pdf";
        if (!isPdf) return null;

        try {
            let base64Data = one_side_PDF_Key.PDF_KEY;
            if (base64Data.startsWith('data:')) {
                base64Data = base64Data.split(',')[1];
            }
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            return URL.createObjectURL(blob);
        } catch (e) {
            console.error("Error creating PDF blob", e);
            // fallback
            return `data:application/pdf;base64,${one_side_PDF_Key.PDF_KEY.replace('data:application/pdf;base64,', '')}`;
        }
    }, [one_side_PDF_Key?.PDF_KEY, one_side_PDF_Key?.FILE_TYPE]);

    const formProgress = useMemo(() => {
        if (!isMounted.current) {
            return
        }
        let total = 0;
        let filled = 0;
        let mandatoryFieldsList = [];
        let filledFieldsList = [];

        activeDocJSON?.forEach(tab => {
            tab.children?.forEach(section => {
                section.children?.forEach(field => {
                    if (field?.children) {
                        field?.children.forEach(child => {
                            if (child.conditional_mandatory && !mandatoryFieldsList.find(item => item.serviceID === child.serviceID)) {
                                let TragetFeildVal = Get_Val_By_ServiceKey(null, JSON.parse(JSON.stringify(activeDocJSON)), child.conditional_mandatory.serviceID);
                                if (child.conditional_mandatory.val.includes(TragetFeildVal)) {
                                    if (child.mandatory !== "true") {
                                        setTimeout(() => {
                                            changeValByserviceID(child.serviceID,
                                                "serviceID",
                                                "mandatory",
                                                "true");
                                        }, 0);
                                    }
                                    total++;
                                    mandatoryFieldsList.push(child);
                                } else {
                                    if (child.mandatory !== "false") {
                                        setTimeout(() => {
                                            changeValByserviceID(child.serviceID,
                                                "serviceID",
                                                "mandatory",
                                                "false");
                                        }, 0);
                                    }
                                }
                            }

                            if (child.render === "true" && child.mandatory === "true") {
                                if (!mandatoryFieldsList.find(item => item.serviceID === child.serviceID)) {
                                    total++;
                                    mandatoryFieldsList.push(child);
                                }
                                if (
                                    child.val !== null &&
                                    child.val !== undefined &&
                                    String(child.val).trim() !== ""
                                ) {
                                    filledFieldsList.push(child)
                                    filled++;
                                }
                            }
                        })
                    }
                    if (field.conditional_mandatory && !mandatoryFieldsList.find(item => item.serviceID === field.serviceID)) {
                        let TragetFeildVal = Get_Val_By_ServiceKey(null, JSON.parse(JSON.stringify(activeDocJSON)), field.conditional_mandatory.serviceID);
                        if (field.conditional_mandatory.val.includes(TragetFeildVal)) {
                            if (field.mandatory !== "true") {
                                setTimeout(() => {
                                    changeValByserviceID(field.serviceID,
                                        "serviceID",
                                        "mandatory",
                                        "true");
                                }, 0);
                            }
                            total++;
                            mandatoryFieldsList.push(field);
                        } else {
                            if (field.mandatory !== "false") {
                                setTimeout(() => {
                                    changeValByserviceID(field.serviceID,
                                        "serviceID",
                                        "mandatory",
                                        "false");
                                }, 0);
                            }
                        }
                    }
                    if (field.render === "true" && field.mandatory === "true") {
                        if (!mandatoryFieldsList.find(item => item.serviceID === field.serviceID)) {
                            total++;
                            mandatoryFieldsList.push(field);
                        }

                        if (
                            field.val !== null &&
                            field.val !== undefined &&
                            String(field.val).trim() !== ""
                        ) {
                            filledFieldsList.push(field)
                            filled++;
                        }
                    }
                });
            });
        });
        console.log({ total, filled, mandatoryFieldsList, activeDocJSON }, "formProgress");

        return {
            total,
            filled,
            mandatoryFieldsList,
            percentage:
                total > 0
                    ? Math.round((filled / total) * 100)
                    : 0
        };

    }, [activeDocJSON]);

    // Snackbar state
    useEffect(() => {
        isMounted.current = true;
        const load = async () => {
            try {
                dispatch(showLoader());
                let activityCodes = await getVendorActivityCode();
                if (!isMounted.current) return;
                setAllActivityCodes(activityCodes || []);
                if (!From_SearchJSON)
                    await fetchDocument()
                else {
                    dispatch(setDOCJSON(From_SearchJSON));
                    console.log(From_SearchJSON, "From_SearchJSON");
                    store_all_vals(From_SearchJSON);
                    let res = await getRequest(
                        `api/vr2/get_screen_dependency_json?module=${localStorage.getItem(
                            "module",
                        )}&screenName=${screenName}`,
                    );
                    if (!isMounted.current) return;
                    if (res?.res?.status === "success") {
                        dispatch(update_dependencyJson(res.res.data));
                    }
                }
            } catch (error) {
                if (!isMounted.current) return;
                dispatch(showAlert("Something went wrong while get_screen_dependency_json or getVendorActivityCode!", "error"));
                console.log(error);
            } finally {
                if (isMounted.current) {
                    dispatch(hideLoader());
                }
            }
        };
        load();
        return () => {
            isMounted.current = false;
        };
    }, [])

    const Store_ORG_ID = async (FROM) => {
        dispatch(Set_ORG_ID_CONST(""));
        const lookup = Get_Val_By_ServiceKey(FROM) || {};
        const val = lookup[FROM];

        if (val) {
            dispatch(Set_ORG_ID_CONST(val));
        } else {
            console.warn(`Store_ORG_ID: No value found for ${FROM}`);
        }
    };

    const putDefaultValue_BillExtract_copyFrom = (TO, FROM) => {
        const val = Get_Val_By_ServiceKey(FROM) || {};
        if (val) {
            putDefaultValue_BillExtract(TO, val);
        } else {
            console.warn(
                `putDefaultValue_BillExtract_copyFrom: No value found for ${FROM}`,
            );
        }
    };

    const fetchDocument = async () => {
        dispatch(showLoader());
        let key = localStorage.getItem("api") || "";
        if (action === "create") {
            try {
                let res = await getRequest(
                    `api/vr2/get_screen_json_repository?module=${localStorage.getItem(
                        "module",
                    )}&screenName=${screenName}`,
                )
                if (res.res.status === "success") {
                    console.log(res.res.data,);
                    console.log("INITIAL FIRST ITEM =", res.res.data[0], screenName);
                    dispatch(setDOCJSON(res.res.data));
                    store_all_vals(res.res.data);
                    // this.props.handleTreeChange(j_son)
                    // this.store_all_vals(j_son)
                    if (screenName == "VendorMaster" || screenName == "ItemMaster" || screenName == "PurchaseOrder" || screenName == "GoodsAndServicesEntries" || screenName === 'OrganizationMaster') {
                        const { res } = await getRequest(`api/vr2/GetMasterObjectID?screenName=${screenName}&context=temp`);
                        changeValByserviceID(screenName === "PurchaseOrder" ? "PO Number" : screenName === "GoodsAndServicesEntries" ? "GRN/SRN Number" : screenName === "ItemMaster" ? "Item ID" : screenName === "VendorMaster" ? "Vendor ID" : screenName === "OrganizationMaster" ? "Organization ID" : '', "serviceKey", "val", res.data);
                    }

                    if (screenName === "BillExtract") {
                        Store_ORG_ID("Organization ID");
                        putDefaultValue_BillExtract("DocumentType", "Bill");
                        putDefaultValue_BillExtract("ExchangeRate", "1");
                        putDefaultValue_BillExtract_copyFrom(
                            "Accounting Date",
                            "Invoice Date",
                        );
                    }
                    if (screenName === "GoodsAndServicesEntries") {
                        Store_ORG_ID("Receiver ID");
                    }

                    getRequest(
                        `api/vr2/get_screen_dependency_json?module=${localStorage.getItem(
                            "module",
                        )}&screenName=${screenName}`,
                    ).then((res) => {
                        if (res.res.status === "success") {
                            console.log(res.res.data);

                            dispatch(update_dependencyJson(res.res.data));
                            // this.props.update_dependencyJson([])

                            if (isMounted.current) {
                                setRender(true);
                            }
                        }
                    });
                }
            } catch (error) {
                console.log(error);
            } finally {
                dispatch(hideLoader());
            }
        }
        else if ((action === "draft" ||
            action === "edit" ||
            action === "approval" ||
            action === "PartialCreate") &&
            key) {
            try {
                dispatch(showLoader())
                let apiParamsInfo = localStorage.getItem("apiParams") || {}
                try {
                    const rawApiParams = localStorage.getItem("apiParams");
                    if (rawApiParams && rawApiParams !== "[object Object]") {
                        apiParamsInfo = JSON.parse(rawApiParams);
                    }
                } catch (e) {
                    console.log("Failed to parse apiParams:", e);
                }
                let res = await postRequest(key, { info: apiParamsInfo })
                if (res && res.res && res.res.status === "success") {
                    dispatch(showLoader())
                    dispatch(setDOCJSON(res.res.data))
                    console.log(res.res.data);

                    store_all_vals(res.res.data)

                    if (screenName === "BillExtract") {
                        Store_ORG_ID("Organization ID");
                        putDefaultValue_BillExtract("DocumentType", "Bill");
                        putDefaultValue_BillExtract("ExchangeRate", "1");
                        putDefaultValue_BillExtract_copyFrom(
                            "Accounting Date",
                            "Invoice Date",
                        );
                    }
                    if (screenName === "GoodsAndServicesEntries") {
                        Store_ORG_ID("Receiver ID");
                    }

                    getRequest(
                        `api/vr2/get_screen_dependency_json?module=${localStorage.getItem(
                            "module",
                        )}&screenName=${screenName}`,
                    ).then((res) => {
                        if (res.res.status === "success") {
                            console.log(res.res.data);

                            dispatch(update_dependencyJson(res.res.data));
                            if (isMounted.current) {
                                setRender(true);
                            }
                        }
                    });
                }
            } catch (error) {
                console.log(error)
            } finally {
                dispatch(hideLoader())
            }

        }
    }

    const validate_Document = useCallback(async (db_commit = false, exitAfterValidation = false, backgroundProcess = false) => {
        setFooterOpen(false);
        if (!backgroundProcess) dispatch(showLoader());
        if (!activeDocJSON) {
            if (!backgroundProcess) dispatch(hideLoader());
            return;
        }

        let firstError = null;

        const findFirstMandatoryError = async (nodes, parentNode = null, rowIndex = null) => {
            if (backgroundProcess)
                return;

            let from_dt, to_dt;
            let forPrdToNode = null;

            for (const node of nodes) {

                if (node.FormatCheck && node.editable === 'true' && node.val !== '' && node.val !== null && node.val !== undefined) {

                    const regex = new RegExp(node.FormatCheck);

                    const isValid = regex.test(String(node.val).trim());

                    console.log("Regex Result =", isValid, node.val);

                    if (!isValid) {

                        console.log("Dispatching Validation Error");
                        return { message: `${node.title} format is invalid`, node };
                    } else {
                        dispatch(
                            updateValidationErrorByKey(
                                node.serviceID,
                                ``
                            )
                        );
                    }
                }

                if (node.DateCheck && node.val != null && node.val != undefined && node.val != "") {
                    let checkCase = node.DateCheck?.includes("_") ? node.DateCheck.split("_")[0] : node.DateCheck;

                    // 1. Get the raw date value from the document
                    let targetDateVal = node.DateCheck?.split("_")[1] ? Get_Val_By_ServiceKey(node.DateCheck?.split("_")[1], activeDocJSON) : null;
                    const formats = ['YYYY-MM-DD', 'DD-MM-YYYY', 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD MMM YYYY'];

                    // 2. Wrap both in dayjs objects
                    let dateA = dayjs(node.val, formats);
                    let dateB = targetDateVal ? dayjs(targetDateVal, formats) : dayjs();

                    // 3. Compare dateA against dateB
                    let isAfter = dateA.isAfter(dateB, "day");
                    let isBefore = dateA.isBefore(dateB, "day");
                    console.log(isAfter, isBefore, dateA, dateB, targetDateVal, node.val);


                    switch (checkCase) {
                        case "isNotFutureDate":
                            if (dayjs(node.val).isAfter(dayjs(), "day")) {
                                return { message: "Future date is not allowed.", node };
                            } else {
                                dispatch(updateValidationErrorByKey(node.serviceID, ""));
                            }
                            break;
                        case "isAfter":
                            if (!isAfter && dateA.isValid() && dateB.isValid() && !dateA.isSame(dateB, "day")) {
                                return { message: `${node?.["serviceKey"]} should be after ${node.DateCheck.split("_")[1] || ''}`, node };
                            }
                            break;
                        case "isBefore":
                            if (!isBefore && dateA.isValid() && dateB.isValid() && !dateA.isSame(dateB, "day")) {
                                return { message: `${node?.["serviceKey"]} should be before ${node.DateCheck.split("_")[1] || ''}`, node };
                            }
                            break;
                        default:
                            dispatch(updateValidationErrorByKey(node.serviceID, ""));
                            break;
                    }
                }

                if (
                    screenName === "CostAllocationMaster" &&
                    node.render === "true" &&
                    node.serviceKey === "ForPrdFrom" &&
                    (!node.val || node.val === "")
                ) {

                    return {
                        message: `ForPrdFrom in Section "${parentNode?.title || ""}" Row no ${rowIndex !== null ? rowIndex + 1 : 1
                            } is mandatory`, node
                    };
                }
                if (
                    node.mandatory === "true" &&
                    node.render === "true" &&
                    node.editable === "true" &&
                    (
                        !node.val ||
                        node.val === "" ||
                        (Array.isArray(node.val) && node.val.length === 0)
                    )
                ) {
                    return { message: `${node?.["serviceKey"]} is mandatory`, node };
                }

                if (
                    node.render === "true" &&
                    node.editable === "true" &&
                    node.val === "Invalid date"
                ) {
                    return node;
                }


                if (node.conditional_mandatory && node.render === "true" && node.editable === "true") {
                    const dependentVal = storeVals[node.conditional_mandatory.serviceID];

                    console.log("DEPENDENT VAL =", dependentVal);

                    if (
                        Array.isArray(node.conditional_mandatory.val) &&
                        node.conditional_mandatory.val.includes(dependentVal) &&
                        (!node.val || node.val === "" || (Array.isArray(node.val) && node.val.length === 0))
                    ) {
                        return { node };
                    }
                }

                if (node.render === "true") {
                    if (node.serviceKey === "ForPrdFrom") from_dt = node.val;
                    if (node.serviceKey === "ForPrdTo") {
                        to_dt = node.val;
                        forPrdToNode = node;
                    }
                }
            }

            if (from_dt && to_dt) {
                const from = dayjs(from_dt, 'DD-MM-YYYY');
                const to = dayjs(to_dt, 'DD-MM-YYYY');
                console.log("from_dt", from_dt, "to_dt", to_dt);
                console.log("from", from, "to", to);

                if (from.isValid() && to.isValid() && !(to.isAfter(from) || to.isSame(from))) {
                    return { message: `Invalid ForPrdTo in Section "${parentNode?.title || ''}" ${rowIndex !== null ? `Row no ${rowIndex + 1}` : ''}`, node: forPrdToNode };
                }
            }

            for (const node of nodes) {
                // if (node.validationCondition?.query) {
                //     let getValFrom = Get_Val_By_ServiceKey(node.validationCondition.compareKey, activeDocJSON);
                //     let obj = {};
                //     node.validationCondition.getValFrom.forEach((key) => {
                //         obj[key] = Get_Val_By_ServiceKey(key, activeDocJSON);
                //     });

                //     if (Object.values(obj).some(item => item === null || item === undefined || item === "")) {
                //         dispatch(showAlert("Please fill all the values", "error"))
                //         return node;
                //     }
                //     let queryResult = await postRequest(
                //         'api/vr2apicall/Validate_Query_Run',
                //         { query: node.validationCondition.query, info: obj }
                //     );

                //     if (queryResult.res.status === 'success' && queryResult.res.data) {
                //         let parsedData = typeof queryResult.res.data === 'string'
                //             ? JSON.parse(queryResult.res.data)
                //             : queryResult.res.data;
                //         if (parsedData.length > 0) {
                //             let compareValue = parsedData[0][node.validationCondition.compareKey];

                //             if (node.validationCondition?.compartor === "<" && ((node.subtype === "date" && dayjs(compareValue).isBefore(getValFrom)) || (node.subtype === "number" && compareValue < getValFrom))) {
                //                 dispatch(updateValidationError(node.serviceID, node.validationCondition?.message));
                //             } else if (node.validationCondition?.compartor === ">" && (node.subtype === "date" && dayjs(compareValue).isAfter(getValFrom)) || (node.subtype === "number" && compareValue > getValFrom)) {
                //                 dispatch(updateValidationError(node.serviceID, node.validationCondition?.message));
                //             } else if (node.validationCondition?.compartor === "=" && (node.subtype === "date" && dayjs(compareValue).isSame(getValFrom)) || ((node.subtype === "number" || node.subtype === "text") && compareValue === getValFrom)) {
                //                 dispatch(updateValidationError(node.serviceID, node.validationCondition?.message));
                //             } else if (node.validationCondition?.compartor === "!=" && (node.subtype === "date" && !dayjs(compareValue).isSame(getValFrom)) || ((node.subtype === "number" || node.subtype === "text") && compareValue !== getValFrom)) {
                //                 dispatch(updateValidationError(node.serviceID, node.validationCondition?.message));
                //             }
                //         }
                //     }
                // }

                if (node.children && Array.isArray(node.children)) {
                    console.log(node);

                    const found = await findFirstMandatoryError(
                        node.children,
                        node.title ? node : parentNode,
                        node.title ? null : nodes.indexOf(node)
                    );
                    console.log("FOUND =", found);

                    if (found) return found;
                }
            }
            return null;
        };

        const errorResult = await findFirstMandatoryError(activeDocJSON);
        console.log("ERROR RESULT =", errorResult);

        const { message, node: errorNode } = errorResult || {};
        console.log("ERROR NODE =", errorNode);

        if (errorNode) {
            const containsNode = (n, target) => {
                if (n === target) return true;
                if (n.children && Array.isArray(n.children)) {
                    return n.children.some(child => containsNode(child, target));
                }
                return false;
            };

            let topLevelNode = null;
            for (const node of activeDocJSON) {
                if (containsNode(node, errorNode)) {
                    topLevelNode = node;
                    break;
                }
            }
            if (topLevelNode) {
                let section = topLevelNode.Section?.trim();
                if (!section) {
                    if (topLevelNode.serviceKey === "#SECTION#01") section = "header-1";
                    else if ((topLevelNode.processcode === "WF" || topLevelNode.processcode === "CED") && topLevelNode.children?.[0]?.view === "table") section = "footer-1";
                    else if (topLevelNode.type === "validate_button" || topLevelNode.type === "submit_button") section = "";
                    else section = "1-body";
                }
                
                const match = section.match(/^(\d+-body)/i);
                const key = match ? match[1] : section;
                
                const groupNodes = activeDocJSON.filter(item => {
                    let s = item.Section?.trim();
                    if (!s) {
                        if (item.serviceKey === "#SECTION#01") s = "header-1";
                        else if ((item.processcode === "WF" || item.processcode === "CED") && item.children?.[0]?.view === "table") s = "footer-1";
                        else if (item.type === "validate_button" || item.type === "submit_button") s = "";
                        else s = "1-body";
                    }
                    const m = s.match(/^(\d+-body)/i);
                    const k = m ? m[1] : s;
                    return k === key;
                });
                
                groupNodes.sort((a, b) => (a.Section || '').toString().localeCompare((b.Section || '').toString(), undefined, { numeric: true }));
                const indexInsideGroup = groupNodes.findIndex(item => item === topLevelNode);
                
                dispatch(setActiveTab(key, indexInsideGroup !== -1 ? indexInsideGroup : 0));
            }


            dispatch(showAlert(message, "error"));
            dispatch(updateValidationErrorByKey(errorNode.serviceID, message));
            dispatch(setFocusedServiceID(errorNode.serviceID));

            setTimeout(() => {
                const element = document.getElementById(errorNode.serviceID);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    element.focus();
                    
                    if (document.activeElement !== element) {
                        const focusableChild = element.querySelector('input, textarea, select, button');
                        if (focusableChild) {
                            focusableChild.focus();
                        }
                    }
                }
            }, 300);

            if (!backgroundProcess) dispatch(hideLoader());

            return {
                status: "error",
                message
            };
        }

        if (!isMounted.current) {
            if (!backgroundProcess) dispatch(hideLoader());
            return;
        }


        console.log('"hello Nothing from validate"');
        if (ORG_ID_CONST === "" || !ORG_ID_CONST) {
            if (screenName === "BillExtract") {
                Store_ORG_ID("Organization ID");
            }
            if (screenName === "GoodsAndServicesEntries") {
                Store_ORG_ID("Receiver ID");
            }
        }

        if (screenName === "BillExtract") {

            let PO_IP_Type =
                Get_Val_By_ServiceKey("PO/IP Type", activeDocJSON) || "";

            if (PO_IP_Type === "PurchaseOrder") {

                let Qty =
                    Get_Val_By_ServiceKey("Qty", activeDocJSON) || [];

                const isNumber = (value) =>
                    !isNaN(value) && Number(value) !== 0;

                const valid =
                    Array.isArray(Qty)
                        ? Qty.every(isNumber)
                        : isNumber(Qty);

                if (!valid && !backgroundProcess) {
                    dispatch(
                        showAlert(
                            "Please enter valid Qty in Billing Summary",
                            "error"
                        )
                    );
                    dispatch(hideLoader());
                    return false;
                }
            }

            const reversalSelection =
                Get_Val_By_ServiceKey(
                    "FullReversal_ProportionateReversal",
                    activeDocJSON
                ) || "";

            const showSelect =
                Get_Val_By_ServiceKey(
                    "showSelect",
                    activeDocJSON
                ) || "";

            if (showSelect === "GoodsReceipt" ||
                showSelect === "ServiceReceipt"
            ) {
                if (!reversalSelection && !backgroundProcess) {
                    dispatch(
                        showAlert(
                            "Please select Full Reversal / Proportionate Reversal",
                            "error"
                        )
                    );

                    dispatch(
                        setFocusedServiceID(
                            "FullReversal_ProportionateReversal"
                        )
                    );

                    dispatch(hideLoader());
                    return false;
                }
            }
        }

        let result;
        try {
            let Input = {
                backgroundProcess,
                ExitAfterValidation: exitAfterValidation,
                TREE_JSON: activeDocJSON,
                ParsedJson: getFormFields(activeDocJSON),
                edit_log: store?.getState()?.dynamicForms?.changesLog,
                db_commit,
                ORG_ID_CONST:
                    ORG_ID_CONST ? ORG_ID_CONST : Get_Val_By_ServiceKey("Organization ID", activeDocJSON) || Get_Val_By_ServiceKey("Receiver ID", activeDocJSON),
                // (screenName === "BillExtract" ? Get_Val_By_ServiceKey("Organization ID", activeDocJSON) :
                //     (screenName === "GoodsAndServicesEntries" ? Get_Val_By_ServiceKey("Receiver ID", activeDocJSON) : "")),
            };

            if (screenName === "BillExtract") {
                let DocumentType = Get_Val_By_ServiceKey("DocumentType", activeDocJSON) || "";
                let BaseValue = Get_Val_By_ServiceKey("Base Value", activeDocJSON) || [];
                let ExchangeRate = Get_Val_By_ServiceKey("ExchangeRate", activeDocJSON) || "";
                let OriginalInvoiceRef = Get_Val_By_ServiceKey("Original Invoice Ref", activeDocJSON) || "";
                let InvoiceRef = Get_Val_By_ServiceKey("Invoice Ref", activeDocJSON) || "";
                let VendorID = Get_Val_By_ServiceKey("Vendor ID", activeDocJSON) || "";
                let BillNumber = Get_Val_By_ServiceKey("Bill Number", activeDocJSON) || "";

                const sum = Array.isArray(BaseValue) ? BaseValue.reduce((acc, curr) => acc + Number(curr || 0), 0) : Number(BaseValue || 0);


                Input = {
                    ...Input,
                    DocumentType,
                    BaseValue: sum,
                    ExchangeRate,
                    OriginalInvoiceRef,
                    InvoiceRef,
                    VendorID,
                    BillNumber,
                };
            }

            if (screenName === "VendorMaster") {
                let VendorID = Get_Val_By_ServiceKey("Vendor ID", activeDocJSON) || "";
                let VendorName = Get_Val_By_ServiceKey("Vendor Name", activeDocJSON) || "";
                let PAN = Get_Val_By_ServiceKey("PAN", activeDocJSON) || "";

                Input = {
                    ...Input,
                    VendorID,
                    VendorName,
                    PAN,
                };
            }

            result = await postRequest(
                `api/vr2/validateDocuments?module=${localStorage.getItem("module")}&screenName=${screenName}`,
                Input
            );
            console.log("VALIDATE RESPONSE =", result);
            if (result.res.status === "success") {
                console.log("SUCCESS RESPONSE");

                if (exitAfterValidation || backgroundProcess) return;

                console.log(
                    "RESPONSE DOCJSON LENGTH =",
                    result?.res?.data?.length
                );
                console.log("FIRST RESPONSE ITEM =", result.res.data[0]);
                console.log(
                    "SUBMIT BUTTON NODE",
                    result.res.data.find(
                        x => x.type === "submit_button"
                    )
                );

                console.log(
                    "VALIDATE BUTTON NODE",
                    result.res.data.find(
                        x => x.type === "validate_button"
                    )
                );
                dispatch(setDOCJSON(result.res.data));

            } else if (result.res.status === "info") {
                let ok = (
                    <Popup
                        noClose={true}
                        content={
                            <>
                                <div className="mt-3 mb-3" align="center">
                                    <div>{result.res.data}</div>
                                </div>

                                <div align="center">
                                    <button
                                        onClick={() => {
                                            setConfirmationDialog(null);
                                        }}
                                        className="btn btn-warning btn-sm ml-1"
                                    >
                                        Ok
                                    </button>
                                </div>
                            </>
                        }
                    />
                );

                setConfirmationDialog(ok);
            }
        } catch (error) {
            console.log(error);
            dispatch(showAlert("Validation failed", "error"));
            return {
                status: "error",
                message: "Validation failed"
            };
        } finally {
            if (!backgroundProcess)
                dispatch(hideLoader());
        }
        if (result.res.status === "success") {
            return {
                status: "success",
                data: result.res.data
            };
        }

        return {
            status: result.res.status,
            message: result.res.data
        }


    }, [activeDocJSON, dispatch, screenName, docId, ORG_ID_CONST]);

    const updateWorkflowJson = (jsonData, activityCode, Status, Reason) => {
        for (const item of jsonData) {
            if (Array.isArray(item.children)) {
                for (const keys of item.children) {
                    if (
                        keys &&
                        (keys.title === "Goods & Services Entries Work Flow" ||
                            keys.title === "Bill Work Flow" ||
                            keys.title === "Item Master Work Flow" ||
                            keys.title === "Vendor Master Work Flow" ||
                            keys.title === "Item Preferences Work Flow" ||
                            keys.title === "Vendor Preferences Work Flow" ||
                            keys.title === "Purchase Order Work Flow" ||
                            keys.title === "Vendor Advance Payment Work Flow" ||
                            keys.title === 'Organization Master Work Flow')
                    ) {
                        console.log("eeee21", activityCode);

                        if (Array.isArray(keys.children)) {
                            for (const child1 of keys.children) {
                                if (child1 && child1.serviceKey.includes("Table")) {
                                    if (Array.isArray(child1.children)) {
                                        console.log("eeee1.2");
                                        for (const activity_code of child1.children) {
                                            console.log("eeee1.1");
                                            if (
                                                activity_code &&
                                                activity_code.title === "Activity Code" &&
                                                activityCode.includes(activity_code.val)
                                            ) {
                                                if (Array.isArray(child1.children)) {
                                                    console.log("eeee1");

                                                    for (const activity_code_status of child1.children) {
                                                        if (
                                                            activity_code_status &&
                                                            activity_code_status.title === "Activity Status"
                                                        ) {
                                                            console.log("eeeee");

                                                            activity_code_status.val = Status;
                                                        } else if (
                                                            activity_code_status &&
                                                            Status === "Rejected" &&
                                                            activity_code_status.title === "Reason"
                                                        ) {
                                                            activity_code_status.val = Reason;
                                                        }
                                                    }
                                                } else {
                                                    console.log("Error: Activity Status");
                                                }
                                            } else if (activity_code.title === "Activity Code") {
                                                setFooterOpen(true);
                                                dispatch(showAlert(`You are not authorized to perform this action ${activity_code?.val} is required`, "error"));
                                                return { status: false, message: `You are not authorized to perform this action ${activity_code?.val}` };
                                            }
                                        }
                                    } else {
                                        console.log("Error: 'child1.children' is not an array");
                                        return { status: false, message: "Error: 'child1.children' is not an array" };
                                    }
                                } else {
                                    console.log("Error: No Table");
                                }
                            }
                        } else {
                            console.log("Error: 'keys.children' is not an array");
                        }
                    } else {
                        console.log("Title Dont match");
                    }
                }
            }
        }

        // Dispatch the action to Redux, and use a deep copy so Redux registers the state change
        const newData = JSON.parse(JSON.stringify(jsonData));
        dispatch(setDOCJSON(newData));

        return { status: true, data: newData };
    };

    const handle3WayMatchingPopup = async () => {
        try {
            let orgid = Get_Val_By_ServiceKey(null, activeDocJSON, "Organization ID") || ORG_ID_CONST || storeVals["organizationid"] || "";
            let interimId = storeVals["billworkflowinfo#interimid"];

            let response = await getRequest(
                `api/vr2/ThreeWayMatching?interimId=${interimId}&orgid=${orgid}`,
            )
            if (response && response.res?.data) {
                const DATA = response.res.data;
                console.log(response.res, "message", {
                    search: "",
                    data: DATA,
                    filteredData: DATA,
                    header: DATA.length ? Object.keys(DATA[0]) : [],
                });
                setPopup_table({
                    search: "",
                    data: DATA,
                    filteredData: DATA,
                    header: DATA.length ? Object.keys(DATA[0]) : [],
                });
            }
        } catch (error) {
            console.error("API request failed:", error);
        }
    };

    const submit_Document = useCallback(async (event, action, reason = null) => {
        setFooterOpen(false);
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        dispatch(showLoader());

        if (action === 'Approve & Activate' || (action === 'Reject & Activate' && reason)) {
            try {
                if (allActivityCodes == '') {
                    dispatch(hideLoader());
                    return;
                }
                setFooterOpen(true);
                let { status, message, data } = updateWorkflowJson(activeDocJSON, allActivityCodes.join(","), action === 'Approve & Activate' ? 'Approved' : (action === 'Reject & Activate' && reason) ? 'Rejected' : '', reason);
                console.log(status, message, data);

                if (!status) {
                    dispatch(showAlert(message, "error"));
                    dispatch(hideLoader());
                    return;
                }
            } catch (err) {
                console.log(err);
                dispatch(hideLoader());
                return;
            }
        }

        let isProceedWithoutGSE = false;
        let found = false;
        let stop = false;
        let stop_2 = false;
        let stop_3 = false;
        let stopAll = false;
        let dont_stop = false;

        //condiotional mandatory
        activeDocJSON?.forEach((each, i) => {
            if (found) return;

            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;

                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, k) => {
                            if (found) return;

                            if (
                                !each3.children &&
                                each3.mandatory &&
                                each3.mandatory === "true" &&
                                each3.render === "true" &&
                                each3.editable === "true" &&
                                !each3.val
                            ) {
                                console.log(each3.serviceID);
                                document.getElementById(each3.serviceID) &&
                                    document.getElementById(each3.serviceID);
                                dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                found = true;
                                return;
                            }

                            if (each3.conditional_mandatory) {
                                if (
                                    each3.conditional_mandatory.val.includes(
                                        storeVals[each3.conditional_mandatory.serviceID],
                                    ) &&
                                    each3.render === "true" &&
                                    each3.editable === "true" &&
                                    !each3.val
                                ) {
                                    console.log(each3.serviceID, '"helohelo321"');
                                    document.getElementById(each3.serviceID) &&
                                        document.getElementById(each3.serviceID);
                                    dispatch(showAlert(`${each3.serviceKey} is mandatory`, "error"));
                                    found = true;
                                    return;
                                }
                            }

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (
                                        each4.mandatory === "true" &&
                                        each4.render === "true" &&
                                        each4.editable === "true" &&
                                        !each4.val
                                    ) {
                                        console.log(each4.serviceID);
                                        document.getElementById(each4.serviceID)?.focus();
                                        dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                        found = true;
                                        return;
                                    }

                                    if (each4.conditional_mandatory) {
                                        if (
                                            each4.conditional_mandatory.val.includes(
                                                storeVals[
                                                each4.conditional_mandatory.serviceID
                                                ],
                                            ) &&
                                            each4.render === "true" &&
                                            each4.editable === "true" &&
                                            !each4.val
                                        ) {
                                            console.log(each4.serviceID, '"helohelo123"');
                                            document.getElementById(each4.serviceID)?.focus();
                                            dispatch(showAlert(`${each4.serviceKey} is mandatory`, "error"));
                                            found = true;
                                            return;
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        //checking forprdfrom and forprdto
        activeDocJSON?.forEach((each, i) => {
            if (found) return;

            if (each.children && each.children.length) {
                each.children.forEach((each2, j) => {
                    if (found) return;

                    if (each2.children && each2.children.length) {
                        each2.children.forEach((each3, row) => {
                            if (found) return;

                            let from_dt;
                            let to_dt;

                            if (each3.children && each3.children.length) {
                                each3.children.forEach((each4, m) => {
                                    if (
                                        each4.render === "true" &&
                                        (each4.serviceKey === "ForPrdFrom" ||
                                            each4.serviceKey === "ForPrdTo")
                                    ) {
                                        if (each4.serviceKey === "ForPrdFrom") from_dt = each4.val;
                                        if (each4.serviceKey === "ForPrdTo") to_dt = each4.val;

                                        if (from_dt && to_dt) {
                                            const from = dayjs(from_dt, 'DD-MM-YYYY');
                                            const to = dayjs(to_dt, 'DD-MM-YYYY');
                                            console.log("from_dt", from_dt, "to_dt", to_dt);
                                            console.log("from", from, "to", to);

                                            if (from.isValid() && to.isValid() && !(to.isAfter(from) || to.isSame(from))) {
                                                console.log(from_dt, to_dt);
                                                console.log(
                                                    `Invalid ForPrdTo in Section "${each2.title
                                                    }" Row no ${row + 1}`,
                                                );
                                                dispatch(showAlert(
                                                    `Invalid ForPrdTo in Section "${each2.title
                                                    }" Row no ${row + 1}`,
                                                    "error"));
                                                found = true;
                                                return;
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
            }
        });

        if (screenName === "BillExtract") {
            // if PO/IP Type = PurchaseOrder then check all Qty is valid number or not
            let PO_IP_Type = Get_Val_By_ServiceKey("PO/IP Type", activeDocJSON) || "";
            console.log(PO_IP_Type);

            if (PO_IP_Type === "PurchaseOrder") {
                let Qty = Get_Val_By_ServiceKey("Qty", activeDocJSON) || "";
                if (!Array.isArray(Qty)) Qty = [Qty];
                console.log(Qty);

                function isNumber(value) {
                    // checking number != 0 and not a number
                    return !isNaN(value) && value != 0;
                }

                const Valid = Qty.every((num) => isNumber(num));

                if (!Valid) {
                    found = true;

                    dispatch(showAlert(`Please enter valid Qty in Billing Summary`, "error"));
                    dispatch(hideLoader());
                    return;
                }
            }
        }

        if (found) {
            dispatch(hideLoader());
            return;
        }
        try {

            setFooterOpen(false);

            let Input = {
                TREE_JSON: activeDocJSON,
                ORG_ID_CONST: ORG_ID_CONST || Get_Val_By_ServiceKey("Organization ID", activeDocJSON) || Get_Val_By_ServiceKey("Receiver ID", activeDocJSON),
                OldAccountingDate: "",
                isForRejection: null,
            };

            if (screenName === "ItemMaster") {
                let ItemID = Get_Val_By_ServiceKey("Item ID", activeDocJSON) || "";
                let ItemName = Get_Val_By_ServiceKey("Item Name", activeDocJSON) || "";

                Input = {
                    ...Input,
                    ItemID,
                    ItemName,
                };
                console.log(Input);
            }

            if (screenName === "VendorMaster") {
                let VendorID = Get_Val_By_ServiceKey("Vendor ID", activeDocJSON) || "";
                let VendorName = Get_Val_By_ServiceKey("Vendor Name", activeDocJSON) || "";
                let PAN = Get_Val_By_ServiceKey("PAN", activeDocJSON) || "";

                Input = {
                    ...Input,
                    VendorID,
                    VendorName,
                    PAN,
                };
                console.log(Input);
            }

            if (screenName === "CostAllocationMaster") {
                let CostAllocationMethod = Get_Val_By_ServiceKey("Cost Allocation Method", activeDocJSON) || "";
                let ForPrdFrom = Get_Val_By_ServiceKey("ForPrdFrom", activeDocJSON) || "";
                let ForPrdTo = Get_Val_By_ServiceKey("ForPrdTo", activeDocJSON) || "";

                Input = {
                    ...Input,
                    CostAllocationMethod,
                    ForPrdFrom,
                    ForPrdTo,
                };
                console.log(Input);
            }

            if (screenName === "BillExtract") {
                let InvoiceRef = Get_Val_By_ServiceKey("Invoice Ref", activeDocJSON) || "";
                let VendorID = Get_Val_By_ServiceKey("Vendor ID", activeDocJSON) || "";
                let BillNumber = Get_Val_By_ServiceKey("Bill Number", activeDocJSON) || "";
                let DocumentType = Get_Val_By_ServiceKey("DocumentType", activeDocJSON) || "";

                Input = {
                    ...Input,
                    InvoiceRef,
                    VendorID,
                    BillNumber,
                    DocumentType,
                };
                console.log(Input);

                // checking cost allocation CostAllocated Lcl Curr is not empty
                activeDocJSON?.forEach((each, i) => {
                    if (found) return;
                    if (each.children && each.children.length) {
                        each.children.forEach((each2, j) => {
                            if (found) return;
                            if (each2.children && each2.children.length) {
                                if (each2.title === "Bill Cost Allocation") {
                                    each2.children.forEach((each3, k) => {
                                        if (each3.children && each3.children.length) {
                                            each3.children.forEach((each4, m) => {
                                                let CostAllocatedLclCurr = [];

                                                if (each4.title === "CostAllocated Lcl Curr") {
                                                    CostAllocatedLclCurr.push(each4.val);

                                                    if (m === each3.children.length - 1) {
                                                        const sum = CostAllocatedLclCurr.reduce(
                                                            (accumulator, currentValue) => {
                                                                const number = Number(currentValue);
                                                                return accumulator + number;
                                                            },
                                                            0,
                                                        );


                                                        if (!sum || isNaN(sum)) {
                                                            stop = true;

                                                            dispatch(showAlert(
                                                                `Cost Allocation is not defined! Please don't activate`,
                                                                "error"));
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                });

                // 0 Value check Col - CostAllocationVariance, AJCrossFootErrorInd, ReversedAJCrossFootErrorInd
                store_all_vals(activeDocJSON);

                let SerIDS = [
                    "costallocationvariance",
                    "ajcrossfooterrorind",
                    "reversedajcrossfooterrorind",
                ];

                SerIDS = SerIDS?.map((each) => trim(each)) || [];

                let obj = {};

                Object.keys(storeVals).forEach((each) => {
                    let key = each.split("#")[1];

                    if (SerIDS.includes(key)) {
                        if (!obj[key]) obj[key] = storeVals[each];
                    }
                });

                console.log(obj); //////////// roundoff

                if (
                    Math.round(obj.costallocationvariance) == 0 &&
                    Math.round(obj.ajcrossfooterrorind) == 0 &&
                    (Math.round(obj.reversedajcrossfooterrorind) == 0 ||
                        !obj.reversedajcrossfooterrorind)
                ) {
                } else {
                    stop_2 = true;

                    dispatch(showAlert(
                        `Bill Cost Error Detection Table Error! Please don't activate`,
                        "error"));
                }
                //Expenses Journal checking LedgerName and AccountCode is not empty
                activeDocJSON?.forEach((each, i) => {
                    if (found) return;
                    if (each.children && each.children.length) {
                        each.children.forEach((each2, j) => {
                            if (found) return;
                            if (each2.children && each2.children.length) {
                                if (found) return;
                                if (
                                    (each2.title === "Billing Summary" && !dont_stop) ||
                                    (each2.title === "Two Way Matching(Bill Vs PO/IP)" &&
                                        !stopAll &&
                                        !dont_stop)
                                ) {
                                    let Qty = {
                                        "Balance in PO/IP": 0,
                                        Bill: 0,
                                        Difference: 0,
                                    };
                                    let Rate = {
                                        "Balance in PO/IP": 0,
                                        Bill: 0,
                                        Difference: 0,
                                    };
                                    let BaseValue = {
                                        "Balance in PO/IP": 0,
                                        Bill: 0,
                                        Difference: 0,
                                    };
                                    each2.children.forEach((each3, k) => {
                                        if (each3.children && each3.children.length) {
                                            let Field;
                                            each3.children.forEach((each4, m) => {
                                                if (
                                                    each4.title === "Fields" &&
                                                    (each4.val === "Qty" ||
                                                        each4.val === "BaseValue" ||
                                                        each4.val === "Rate")
                                                ) {
                                                    Field = each4.val;
                                                }

                                                if (
                                                    Field == "BaseValue" &&
                                                    (each4.title == "Balance in PO/IP" ||
                                                        each4.title == "Bill" ||
                                                        each4.title == "Difference")
                                                ) {
                                                    BaseValue = {
                                                        ...BaseValue,
                                                        [each4.title]: each4.val.includes("-")
                                                            ? parseInt(each4.val.replace("-", ""))
                                                            : parseInt(each4.val),
                                                    };
                                                }

                                                if (
                                                    Field == "Rate" &&
                                                    (each4.title == "Balance in PO/IP" ||
                                                        each4.title == "Bill" ||
                                                        each4.title == "Difference")
                                                ) {
                                                    Rate = {
                                                        ...Rate,
                                                        [each4.title]: each4.val.includes("-")
                                                            ? parseInt(each4.val.replace("-", ""))
                                                            : parseInt(each4.val),
                                                    };
                                                }

                                                if (
                                                    Field == "Qty" &&
                                                    (each4.title == "Balance in PO/IP" ||
                                                        each4.title == "Bill" ||
                                                        each4.title == "Difference")
                                                ) {
                                                    console.log(each4);

                                                    Qty = {
                                                        ...Qty,
                                                        [each4.title]: each4.val.includes("-")
                                                            ? parseInt(each4.val.replace("-", ""))
                                                            : parseInt(each4.val),
                                                    };
                                                }
                                                console.log(
                                                    BaseValue.Difference,
                                                    Qty.Difference,
                                                    Rate.Difference,
                                                    each2.title === "Two Way Matching(Bill Vs PO/IP)" &&
                                                    (BaseValue.Difference !== 0 ||
                                                        Qty.Difference !== 0 ||
                                                        Rate.Difference !== 0),
                                                    each2.title === "Billing Summary" &&
                                                    each4.title === "Order ID" &&
                                                    each4.val === "",
                                                );

                                                if (
                                                    (each2.title === "Billing Summary" &&
                                                        each4.title === "Order ID" &&
                                                        each4.val === "") ||
                                                    (each2.title === "Two Way Matching(Bill Vs PO/IP)" &&
                                                        (BaseValue.Difference !== 0 ||
                                                            Qty.Difference !== 0 ||
                                                            Rate.Difference !== 0))
                                                ) {
                                                    stopAll = true;

                                                    setConfirmationDialog(
                                                        <Popup
                                                            isOpen={true}
                                                            closeOnOverlayClick={false}
                                                            content={
                                                                <>
                                                                    <div style={{ padding: "20px", textAlign: "center" }}>
                                                                        {each4.title === "Order ID" && each4.val === ""
                                                                            ? "Do you want to proceed without mapping a Goods & Services Entry (GSE)?"
                                                                            : "Discrepancy Detected in Rate/Quantity/Base Value. Please verify Two-Way Matching between Bill and PO/IP."}
                                                                        <div style={{ marginTop: "20px" }}>
                                                                            <button className="btn btn-secondary btn-sm mr-2" onClick={() => setConfirmationDialog(null)}>Cancel</button>
                                                                            <button className="btn btn-warning btn-sm" onClick={async () => {
                                                                                setConfirmationDialog(
                                                                                    <Popup
                                                                                        isOpen={true}
                                                                                        closeOnOverlayClick={false}
                                                                                        content={
                                                                                            <>
                                                                                                <div style={{ padding: "20px", textAlign: "center" }}>
                                                                                                    {`• You are proceeding without a mapped Goods & Services Entry (GSE) for this bill. GSE may not be applicable for certain items such as:
   – Electricity, Water Tax, Property Tax, Internet, Salaries, Fuel, etc.
• Please ensure this bill falls under such exempted categories.
• If not, review and map the appropriate GSE.
• Reconfirmation Needed:   Do you want to continue without Goods & Services Entry?`}
                                                                                                    <div style={{ marginTop: "20px" }}>
                                                                                                        <button className="btn btn-secondary btn-sm mr-2" onClick={() => setConfirmationDialog(null)}>Cancel</button>
                                                                                                        <button className="btn btn-warning btn-sm" onClick={async () => {
                                                                                                            setConfirmationDialog(null);
                                                                                                            dispatch(showLoader());
                                                                                                            try {
                                                                                                                const result = await postRequest(
                                                                                                                    `api/vr2/UpdateDocuments?module=${localStorage.getItem("module")}&screenName=${screenName}&context=${action === "PartialCreate" ? "create" : action}`,
                                                                                                                    Input
                                                                                                                );
                                                                                                                if (result?.res?.status === "success") {
                                                                                                                    dispatch(showAlert(result?.res?.message || "Document Activated Successfully", "success"));
                                                                                                                    if (action === "edit" || action === "approval") {
                                                                                                                        setTimeout(() => {
                                                                                                                            window.close();
                                                                                                                        }, 1000);
                                                                                                                    } else {
                                                                                                                        onBack?.();
                                                                                                                    }
                                                                                                                }
                                                                                                            } finally {
                                                                                                                dispatch(hideLoader());
                                                                                                            }
                                                                                                        }}>Proceed</button>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </>
                                                                                        }
                                                                                    />
                                                                                );
                                                                            }}>Proceed</button>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            }
                                                        />
                                                    );
                                                    return;
                                                }
                                            });
                                        }
                                    });
                                }
                                if (each2.title === "Expenses Journal") {
                                    each2.children.forEach((each3, k) => {
                                        if (each3.children && each3.children.length) {
                                            let AccountType;
                                            each3.children.forEach((each4, m) => {
                                                let errMsg;
                                                if (each4.title === "AccountType")
                                                    AccountType = each4.val;

                                                if (
                                                    AccountType &&
                                                    AccountType === "CreditorsAc" &&
                                                    each4.title === "SubLedgerName"
                                                ) {
                                                    if (!each4.val)
                                                        errMsg = `${each4.title} is empty in Expenses Journal`;
                                                }
                                                if (
                                                    each4.title === "AccountingDate" ||
                                                    each4.title === "AccountType" ||
                                                    each4.title === "ItemType" ||
                                                    each4.title === "LedgerName"
                                                ) {
                                                    if (!each4.val)
                                                        errMsg = `${each4.title} is empty in Expenses Journal`;
                                                }
                                                if (each4.title === "AccountCode") {
                                                    if (
                                                        !each4.val ||
                                                        each4.val === "null" ||
                                                        each4.val === "0" ||
                                                        each4.val === "0.0"
                                                    ) {
                                                        errMsg = `${each4.title} is not valid in Expenses Journal`;
                                                    }
                                                }
                                                if (errMsg) {
                                                    found = true;
                                                    stop_3 = true;

                                                    dispatch(showAlert(errMsg, "error"));
                                                }
                                            });
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
            }

            if (stop || stop_2 || stop_3 || stopAll) {
                dispatch(hideLoader());
                return;
            }

            const result = await postRequest(
                `api/vr2/UpdateDocuments?module=${localStorage.getItem(
                    "module"
                )}&screenName=${screenName}&context=${action === "PartialCreate" ? "create" : action
                }`,
                Input
            );

            console.log("ACTIVATE RESPONSE =", result);

            if (result?.res?.status === "success") {
                dispatch(
                    showAlert(
                        result?.res?.message || "Document Activated Successfully",
                        "success"
                    )
                );
                if (action === "edit" || action === "approval") {
                    setTimeout(() => {
                        window.close();
                    }, 1000);
                } else {
                    onBack?.();
                }
            }

            if (result?.res?.status === "info") {

                let ok = (
                    <DialougeBox
                        status={"info"}
                        onClose={() => setConfirmationDialog(null)}
                        message={result?.res?.data?.message}
                        operation={() => {
                            handleExtend(
                                result.res.data.ID,
                                result.res.data.Name,
                                activeDocJSON,
                                Get_Val_By_ServiceKey("Organization ID", activeDocJSON)
                            );
                        }}
                    />
                );

                setConfirmationDialog(ok);
            }
        } catch (err) {
            console.log(err);
            dispatch(showAlert("Activation Failed", "error"));
        } finally {
            dispatch(hideLoader());
        }
    }, [
        activeDocJSON,
        ORG_ID_CONST,
        screenName,
        action,
        dispatch,
        onBack
    ]);


    const handleExtend = async (ID, Name, activeDocJSON, ORG_ID) => {
        try {
            dispatch(showLoader());
            let url =
                screenName === "ItemMaster"
                    ? `api/edureka/getItemJSONForExtension`
                    : `api/edureka/getVendorJSONForExtension`;

            let res = await getRequest(url);
            if (res.res.status === "success") {
                let VR2Json = await res.res.data;
                const orgName = Get_Val_By_ServiceKey("Organization Name", activeDocJSON) || "";
                setScreenName(screenName === "ItemMaster" ? "ItemPreferences" : "VendorPreferences");
                setConfirmationDialog(false)
                const updatedJSONData = [...VR2Json];
                const children = updatedJSONData[1].children[0].children;

                const updateField = (title, value) => {
                    const index = children.findIndex((item) => item.title === title);
                    if (index !== -1) {
                        children[index].val = value;
                    }
                };

                updateField(
                    (screenName === "ItemMaster" && "Item Name") || "Vendor Name",
                    Name,
                );
                updateField(
                    (screenName === "ItemMaster" && "Item ID") || "Vendor ID",
                    ID,
                );
                updateField(
                    "Organization Name",
                    orgName,
                );
                updateField("Organization ID", ORG_ID_CONST || ORG_ID);

                if (screenName === 'VendorPreferences') {
                    const SOSval = Get_Val_By_ServiceKey("Source of Supply", activeDocJSON) || "";
                    updateField("Source of Supply", SOSval);
                    const GSTINval = Get_Val_By_ServiceKey("GSTIN", activeDocJSON) || "";
                    updateField("GSTIN", GSTINval);
                    const BRval = Get_Val_By_ServiceKey("Bank Ref", activeDocJSON) || "";
                    updateField("Bank Ref", BRval);
                    const BNval = Get_Val_By_ServiceKey("Bank Name", activeDocJSON) || "";
                    updateField("Bank Ref", BNval);
                    const BRCval = Get_Val_By_ServiceKey("Branch Name", activeDocJSON) || "";
                    updateField("Branch Name", BRCval);
                    const AcntType = Get_Val_By_ServiceKey("Account Holder Name", activeDocJSON) || "";
                    updateField("Account Holder Name", AcntType);
                    const AcntNo = Get_Val_By_ServiceKey("Account Number", activeDocJSON) || "";
                    updateField("Account Number", AcntNo);
                    const IFSCval = Get_Val_By_ServiceKey("IFSC Code", activeDocJSON) || "";
                    updateField("IFSC Code", IFSCval);
                }

                // Dispatch the updated JSON tree to the store to re-render the dynamic form
                dispatch(setDOCJSON(updatedJSONData));
            }
        } catch (error) {
            console.log(error);
        } finally {
            dispatch(hideLoader());
        }
    };

    const toggleFooter = useCallback(() => {
        setFooterOpen(prev => !prev);
    }, []);

    useEffect(() => {
        return () => { dispatch(setInitialState()) };
    }, [dispatch])

    useEffect(() => {
        if (DOCJSON && Array.isArray(DOCJSON) && DOCJSON.length > 0 && (!reduxDocJSON || (Array.isArray(reduxDocJSON) && reduxDocJSON.length === 0))) {
            dispatch(setDOCJSON(DOCJSON))
            let orgid = Get_Val_By_ServiceKey("Organization ID", DOCJSON)
            dispatch(setOrgIdConst(orgid))
        }
    }, [DOCJSON, reduxDocJSON, dispatch])
    // console.log("ACTIVE DOCJSON =", activeDocJSON);

    const categories = useMemo(() => {
        const header = {};
        const body = {};
        const footer = {};

        if (Array.isArray(activeDocJSON)) {
            activeDocJSON.forEach((item) => {
                let section = item.Section?.trim();

                if (!section) {
                    if (item.serviceKey === "#SECTION#01") {
                        section = "header-1";
                    } else if (
                        (item.processcode === "WF" || item.processcode === "CED") && item.children?.[0]?.view === "table"
                    ) {
                        section = "footer-1";
                    } else if (item.type === "validate_button" || item.type === "submit_button") {
                        section = "";
                    } else {
                        section = "1-body";
                    }
                }

                if (section.toLowerCase().startsWith('header-')) {
                    if (!header[section]) header[section] = [];
                    header[section].push(item);
                    header[section].sort((a, b) => (a.Section || '').toString().localeCompare((b.Section || '').toString(), undefined, { numeric: true }));
                } else if (section.toLowerCase().includes('-body')) {
                    const match = section.match(/^(\d+-body)/i);
                    const key = match ? match[1] : section;
                    if (!body[key]) body[key] = [];
                    body[key].push(item);
                    body[key].sort((a, b) => (a.Section || '').toString().localeCompare((b.Section || '').toString(), undefined, { numeric: true }));
                } else if (section.toLowerCase().startsWith('footer-')) {
                    if (!footer[section]) footer[section] = [];
                    footer[section].push(item);
                    footer[section].sort((a, b) => (a.Section || '').toString().localeCompare((b.Section || '').toString(), undefined, { numeric: true }));
                }
            });
        }
        return { header, body, footer };
    }, [activeDocJSON]);

    const HeaderCategories = categories.header;
    const BodyCategories = categories.body;
    const FooterCategories = categories.footer;
    return (<>
        {
            popup_table && (
                <Popup
                    title={"3 Way Matching Review"}
                    content={
                        <>
                            <div className="row m-4">
                                {!popup_table
                                    ?.filteredData
                                    ?.length ? (
                                    <div>
                                        No match found
                                    </div>
                                ) : (
                                    <TableContainer component={Paper} style={{ maxHeight: '60vh' }}>
                                        <Table stickyHeader size="small">
                                            <TableHead>
                                                <TableRow>
                                                    {popup_table.header?.map(
                                                        (each, indx) => {
                                                            return (
                                                                <TableCell key={indx} style={{ fontWeight: 'bold' }}>
                                                                    {each}
                                                                </TableCell>
                                                            );
                                                        }
                                                    )}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {popup_table.filteredData?.map(
                                                    (each, index) => {
                                                        return (
                                                            <TableRow
                                                                key={index}
                                                                hover
                                                                style={
                                                                    each.disabled
                                                                        ? {
                                                                            opacity: 0.5,
                                                                            pointerEvents: "none",
                                                                        }
                                                                        : null
                                                                }
                                                            >
                                                                {popup_table.header?.map(
                                                                    (one, indx) => {
                                                                        return (
                                                                            <TableCell key={indx}>
                                                                                {each[one]}
                                                                            </TableCell>
                                                                        );
                                                                    }
                                                                )}
                                                            </TableRow>
                                                        );
                                                    }
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                )}
                            </div>
                        </>
                    }
                    handleClose={() =>
                        this.setState({
                            open_popup_select: false,
                            popup_table: false,
                        })
                    }
                />
            )}
        {confirmationDialog}
        <Box sx={{
            height: 'calc(100vh - 64px)',
            overflow: 'hidden',
            bgcolor: '#ffffff', // Clean white background
        }}>
            <ResizablePanelGroup direction="horizontal" className="h-full w-full">
                <ResizablePanel defaultSize={openDragableDialog ? 70 : 100}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%',
                        p: 1,
                        gap: 1
                    }}>
                        <Box sx={{ flex: 'none' }}>
                            {isLoading ? <DocumentHeaderSkeleton /> : Object.values((HeaderCategories && Object.keys(HeaderCategories).length > 0) ? HeaderCategories : {
                                "header-1": [{
                                    "ScreenName": screenName,
                                    "moduleName": localStorage.getItem('module'),
                                }]
                            }).map((item, index) => (
                                <DocumentHeader
                                    key={index}
                                    title={
                                        item.length === 1
                                            ? item[0].title
                                            : item.map((i) => i.title).join(' / ')
                                    }
                                    HeaderJson={item[0].children?.[0]?.children || []}
                                    options={activeDocJSON.filter((item) => item && (item.type === "validate_button" || item.type === "submit_button") && item.render === "true")}
                                    onOpenChange={setOpenDragableDialog}
                                    screenName={screenName}
                                    formProgress={formProgress}
                                    onValidate_Document={validate_Document}
                                    onSubmit_Document={submit_Document}
                                    onBack={onBack}
                                    setConfirmationDialog={setConfirmationDialog}
                                />
                            ))}
                        </Box>

                        <Box sx={{ flex: 1, overflow: 'hidden', position: 'relative' }}>
                            <ResizablePanelGroup
                                direction="vertical"
                                className="h-full rounded-lg w-full"
                            >
                                <ResizablePanel
                                    defaultSize={footerOpen ? 50 : 100}
                                    sx={{
                                        position: 'relative',
                                        transition: 'flex 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                    }}
                                >
                                    <Box sx={{ overflowY: 'auto', p: 1, height: '100%' }}>
                                        {isLoading ? (
                                            <Stack spacing={2}>
                                                <DocumentHeaderSkeleton />
                                                <DocumentHeaderSkeleton />
                                            </Stack>
                                        ) : Object.values(BodyCategories).map((item, index) => (
                                            <DynamicTabsComponent
                                                onOpenChange={setOpenDragableDialog}
                                                key={index}
                                                id={`${index + 1}-body`}
                                                titles={item.map((i) => ({ status: 'wait', title: i.title }))}
                                                DynamicJson={item}
                                                isBodySection={true}
                                                screenName={screenName}
                                            />
                                        ))}
                                    </Box>

                                    {/* Overlay to reduce visual confusion when footer is open */}
                                    <Box
                                        onClick={toggleFooter}
                                        sx={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            bgcolor: 'rgba(0, 0, 0, 0.5)',
                                            backdropFilter: 'blur(6px)',
                                            zIndex: 2000,
                                            cursor: 'pointer',
                                            transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
                                            opacity: footerOpen ? 1 : 0,
                                            pointerEvents: footerOpen ? 'auto' : 'none',
                                            visibility: footerOpen ? 'visible' : 'hidden'
                                        }}
                                    />
                                </ResizablePanel>

                                {FooterCategories && Object.keys(FooterCategories).length > 0 ? <DocumentFooter
                                    footerOpen={footerOpen}
                                    toggleFooter={toggleFooter}
                                    FooterCategories={FooterCategories}
                                    isLoading={isLoading}
                                /> : null}
                            </ResizablePanelGroup>
                        </Box>
                    </Box>
                </ResizablePanel>

                {openDragableDialog && (
                    <>
                        <ResizableHandle withHandle direction="horizontal" />
                        <ResizablePanel defaultSize={30}>
                            <Box sx={{ p: 1, display: 'flex', flexDirection: 'column', height: '100%', borderLeft: '1px solid', borderColor: 'divider' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                    <Typography variant="h6">Attachment PDF</Typography>
                                    <IconButton onClick={() => setOpenDragableDialog(false)} size="small"><X fontSize="small" /></IconButton>
                                </Box>
                                <Box sx={{ flex: 1, height: '100%', overflow: 'hidden' }}>
                                    {one_side_PDF_Key?.PDF_KEY ? (
                                        <iframe
                                            src={
                                                pdfBlobUrl ||
                                                (one_side_PDF_Key?.PDF_KEY.startsWith('data:')
                                                    ? one_side_PDF_Key?.PDF_KEY
                                                    : `data:image/${one_side_PDF_Key?.FILE_TYPE || 'jpeg'};base64,${one_side_PDF_Key?.PDF_KEY}`)
                                            }
                                            style={{ width: '100%', height: '100%', border: 'none', borderRadius: '4px' }}
                                            title="pdf-viewer"
                                        />
                                    ) : (
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: 'text.secondary' }}>
                                            No attachment available
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        </ResizablePanel>
                    </>
                )}
            </ResizablePanelGroup>
        </Box>
    </>)
}

export default DisplayContainer